import { useFormik } from 'formik';
import { useState } from 'react';
import styles from './delete-users-confirm.module.scss';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { Modal } from 'src/components/design-system';
import { COLLABORATOR_PERMISSIONS_GROUP } from 'shared/constants';
import { OwnerSelector } from 'src/components/ownerSelector';

export function DeleteUserConfirm({ open = false, onConfirm, onDismiss, user }) {
  user = user ?? {};
  const [isLoading, setLoadingState] = useState(false);
  const [error, setError] = useState(null);

  const lang = useSelector(getLang('USERS_MANAGEMENT'));

  const onSubmit = async ({ ownerId }) => {
    setLoadingState(true);
    setError(null);

    // Call the delete user action
    let res = await onConfirm({ ownerId });

    if (res?.error) {
      setError(res.error);
    } else {
      onDismiss();
    }

    setLoadingState(false);
  };

  // Check if the user is a collaborator or account admin
  const isCollaborator = COLLABORATOR_PERMISSIONS_GROUP.includes(user.permissions);

  // Schema
  const DELETE_USER_SCHEMA = Yup.object().shape({
    ownerId: isCollaborator ? Yup.string().required('Required') : Yup.string().nullable(),
  });

  const { handleSubmit, setFieldValue, errors, isValid } = useFormik({
    validationSchema: DELETE_USER_SCHEMA,
    initialValues: {
      ownerId: null,
    },
    onSubmit,
  });

  const messageText = isCollaborator
    ? lang.DELETE_USER_POPUP_TEXT_REPLACE_OWNER
    : lang.DELETE_USER_POPUP_TEXT;

  const message = messageText.replace('{name}', `${user?.firstName} ${user?.lastName}`);

  return (
    <Modal
      open={open}
      title={lang.DELETE_USER_POPUP_TITLE}
      onSubmit={handleSubmit}
      submitText={lang.DELETE_USER_POPUP_CONFIRM}
      cancelText={lang.DELETE_USER_POPUP_DISMISS}
      onCancel={onDismiss}
      submitDisabled={!isValid || isLoading}
      loading={isLoading}
      submitButtonType="primary"
      submitDanger>
      <form onSubmit={handleSubmit}>
        <p className={styles.content}>{message}</p>

        {isCollaborator && (
          <OwnerSelector
            currentOwnerId={user.id}
            error={errors.ownerId}
            placeholder={lang.DELETE_USER_POPUP_OWNER_PLACEHOLDER}
            name="ownerId"
            onChange={setFieldValue}
          />
        )}

        {error && <span className={styles.errorMessage}>{error}</span>}
      </form>
    </Modal>
  );
}
